export type FieldValues<T extends string> = Partial<Record<T, string>>;
export type DirtyFields<T extends string> = Partial<Record<T, boolean>>;
export type NestedFormValue<T extends string> = Record<string, FieldValues<T>>;

export type Form<T> = {
  fields: Record<string, FormInputConfig<T>>;
};

export type FormConfig<T> = {
  inputs: FormInputConfig<T>[];
  title: string;
  active: boolean;
};

export interface FormInputConfig<T> {
  id: T;
  type: InputType;
  initialValue?: string;
  active: boolean;
  autocomplete?: string;
  grid?: FormFieldGrid;
  options?: Array<FormInputOptions>;
  colorContrastRatioRules?: ColorContrastRatioRule[];
  isEmptyLabel?: boolean;
  fieldIsLoading?: () => void;
  fieldHasLoaded?: () => void;
}

export enum InputType {
  "cardNumber" = "cardNumber",
  "cardNumberLength" = "cardNumberLength",
  "selectNetwork" = "selectNetwork",
  "securityCode" = "securityCode",
  "text" = "text",
  "dynamic" = "dynamic",
  "select" = "select",
  "checkbox" = "checkbox",
  "title" = "title",
  "subTitle" = "subTitle",
  "currentAddress" = "currentAddress",
  "currentAddressWithEdit" = "currentAddressWithEdit",
  "checkSampleImg" = "checkSampleImg",
  "autocomplete" = "autocomplete",
  "linkWithPaze" = "linkWithPaze",
  "consentCheckbox" = "consentCheckbox",
}

export interface FormInputOptions {
  value: string;
  title: string;
  disabled?: boolean;
}
export interface FormFieldGrid {
  small: {
    flex?: string;
    marginTop?: string;
    marginBottom?: string;
    minWidth?: string;
  };
  medium: {
    flex?: string;
    marginTop?: string;
    marginBottom?: string;
    minWidth?: string;
  };
  large?: {
    flex?: string;
    marginTop?: string;
    marginBottom?: string;
    minWidth?: string;
  };
}

export type ColorContrastRatioRule = {
  ratio: number;
  fields: string[];
  unlessFields?: {
    ratio: number;
    first: string;
    second: string;
  };
};
export interface MandateVerbiage {
  locale: string;
  verbiage: string;
}
export interface MandateConfig {
  mandateId: string;
  enabled: boolean;
  mandateRef: string;
  showAcknowledgement: boolean;
  acknowledgementRequired: boolean;
  mandateVerbiages: Array<MandateVerbiage>;
}

export enum PaymentType {
  creditCard = "cardPaymentMethod",
  eCheck = "ecpPaymentMethod",
  applePay = "applePayPaymentMethod",
  googlePay = "googlePayPaymentMethod",
  sepa = "sepaPaymentMethod",
  paze = "pazePaymentMethod",
  payByBank = "payByBankPaymentMethod",
  ideal = "ideal",
  alipay = "alipay",
  wechatPay = "wechatPay",
  paypal = "paypal",
  trustly = "trustly",
  giftCard = "giftCardPaymentMethod",
}

export enum FormErrorCode {
  expired = 0,
  cardTypeError = 1,
}
